export default __webpack_public_path__ + "static/media/12.72c12e56.jpg";